
/** 超级权限 */
export namespace SuperPowerKind {

    /** 通用数值 */  
    export enum GeneralValue {
        
    }

    export const SuperPowerPropList = [50013, 50014, 50015, 50016];

}